import css from 'styled-jsx/css';

const styles = css.global`.custom-tabs.tabs-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 0 32px 0;
    overflow: hidden;
  }
  
  .custom-tabs.tabs-container .tab-item {
    box-sizing: border-box;
    flex: 0 0 195px !important;
    cursor: pointer;
    width: 195px;
  }

  .custom-tabs.tabs-container .tab-item.sf-tab-central-financiamentos {
    flex: 0 0 242px !important;
    width: 242px;
  }

  .custom-tabs.tabs-container .tab-item.sf-tab-central-emprestimos {
    flex: 0 0 212px !important;
    width: 212px;
  }
  
  .custom-tabs.tabs-container .tab-item p {
    font-family: 'SantanderText';
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    text-align: center;
    color: #222222;
    margin-bottom: 9px;
    transition: color linear 350ms;
  }
  
  .custom-tabs.tabs-container .tab-item span {
    display: block;
    background-color: #767676;
    height: 1px;
    width: 100%;
    box-sizing: border-box;
    transition: background-color linear 350ms;
  }
  
  .custom-tabs.tabs-container .tab-item.active p {
    color: #cc0000!important;
  }
  
  .custom-tabs.tabs-container .tab-item.active span {
    background-color: #cc0000;
    height: 2px;
  }
  
  .sf-tabs-scroll .embla__next,
  .sf-tabs-scroll .embla__prev {
    display: none !important;
  }
  
  #banco-do-auto-banner + .custom-tabs  .tab-item p {
    color: #fff;
  }
  
  #banco-do-auto-banner + .custom-tabs {
    background-color: #181818;
  }
  
  @media (min-width: 576px) {
    .custom-tabs.tabs-container .tab-item {
      flex: 0 0 195px !important;
    }
  }
  
  @media (min-width: 992px) {
    .custom-tabs.tabs-container .tab-item p {
      margin-bottom: 10px;
    }
  
    .custom-tabs.tabs-container {
      padding: 40px 0 48px;
    }
  }
  
  @media(max-width: 992px){
    #banco-do-auto-banner + .custom-tabs {
      background-color: #181818;
      justify-content: flex-start;
        overflow: auto;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }
  }`;

export default styles;